import React from "react";
import './Cards.scss'
import { Card, Slot, Button, Tooltip, ButtonGroup, ButtonIcon, CardV2 } from "pepsico-ds";
import InfoIcon from '../Icons/InfoIcon'
import CustomButtons from "./CustomButtons";

function AppCard({ key, cardName, cardDesc, apps, onSelect, isAmesaUser, item, disabled=false }) {
	// console.log(apps);

	const openApp = (url) => {
		window.open(url, "_blank");
	};
	const buttonGroupItems = apps?.filter(item => item.display)?.map((app) => ({ // ?.filter(item => !item.isAmesaUser)
		label: app.app,
		onClick: () => window.open(app.url, "_blank"), // Opens the app in a new tab
	}));


	return (
		<>

                            <div
									style={{
										minHeight: "150px",
										width: "100%",
										height: "100%",
										display: "flex",
										flexDirection: "column",
										justifyContent: "space-between",
									}}
								>
									<div className="card-title-container">
										<div className="card-title">{cardName}</div>
										<div className="card-description">{cardDesc}</div>
									</div>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'flex-end'
										}}
										className="app-card-footer"
									>
										{
											item?.info &&
											<span style={{ marginRight: "10px" }}><InfoIcon text={item?.info} direction="top-middle"/></span>
										}

											<CustomButtons appList={apps} disabled={disabled}/>
									</div>
                            </div>

            
			
		</>
	);
}

export default AppCard;
